module.exports = __webpack_public_path__ + "fonts/pld-charts-icons.eot";